export interface IArticleChild {
    children: IArticleChild[];
    type?: 'root' | 'element' | 'text';
    value?: string;
    tag?: string;
    props?: { [path in string]: string };
}

export interface IArticle {
    title: string;
    img: string;
    date: string; // 2022-05-08
    tag: string; // how-to
    description?: string;
    path?: string;
    body?: {
        children: IArticleChild[];
    };
}

// Fields a post card (components/Article.vue) needs. List/hub pages must
// `.select(...BLOG_CARD_FIELDS)` rather than fetching whole posts: the query
// result is serialised into the page's inline __NUXT_DATA__ payload, and full
// post bodies made /blog, /casestudies and every category page ~10MB.
export const BLOG_CARD_FIELDS = ['path', 'title', 'date', 'img', 'tag', 'description'] as const;

export function localDate(date: Date | string | number) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(date).toLocaleDateString('en', options as any);
}

export function html(root: IArticle, obj?: IArticleChild, length = 150) {
    let str = obj ? '' : root.description || '';
    if (obj?.type === 'text' && obj.value !== root.title && obj.value !== localDate(root.date)) {
        // console.log('obj', obj);
        str += obj.value;
    }
    for (const child of obj?.children || []) {
        str += html(root, child, 99999);
    }
    if (str.length > length) {
        const l = str.lastIndexOf(' ', length);
        return str.substring(0, l) + '...';
    } else {
        return str;
    }
}
